var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModulos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#69CDFF"
    },
    cx: 267,
    cy: 256,
    r: 245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.72,
    y: 358.53,
    style: {
      fill: "#445EA0"
    },
    width: 78.71,
    height: 41.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.72,
    y: 358.53,
    style: {
      fill: "#2E4C89"
    },
    width: 19.842,
    height: 41.23
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M316.856,398.763H127.56c-2.806,0-5.101,2.296-5.101,5.102v25.571c0,2.806,2.296,5.102,5.101,5.102 h189.296L316.856,398.763L316.856,398.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2B63"
    },
    d: "M142.301,429.435v-25.571c0-2.806,2.296-5.102,5.102-5.102H127.56c-2.806,0-5.101,2.296-5.101,5.102 v25.571c0,2.806,2.296,5.102,5.101,5.102h19.842C144.597,434.537,142.301,432.241,142.301,429.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M445.054,58.964H5.102C2.296,58.964,0,61.26,0,64.066V354.43c0,2.807,2.296,5.102,5.102,5.102 h311.754V206.768c0-3.859,3.14-7,7-7h126.3V64.066C450.156,61.26,447.86,58.964,445.054,58.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M22.396,308.514c0,1.684,1.377,3.06,3.061,3.06h291.399V206.768c0-3.859,3.14-7,7-7H427.76v-90.77 H22.396V308.514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9EAFC"
    },
    d: "M42.239,308.514V108.998H22.396v199.516c0,1.684,1.377,3.06,3.061,3.06H45.3 C43.616,311.574,42.239,310.197,42.239,308.514z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#445EA0"
    },
    cx: 225.08,
    cy: 335.46,
    r: 13.774
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M316.856,223.146h-53.424c-1.65,0-3,1.35-3,3v59.639c0,1.65,1.35,3,3,3h53.424V223.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC1ED"
    },
    d: "M280.274,285.785v-59.639c0-1.65,1.35-3,3-3h-19.842c-1.65,0-3,1.35-3,3v59.639c0,1.65,1.35,3,3,3 h19.842C281.624,288.785,280.274,287.435,280.274,285.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M323.856,199.768h46.618v-65.382c0-2.75-2.25-5-5-5H84.682c-2.75,0-5,2.25-5,5v66.525 c0,2.75,2.25,5,5,5h232.233C317.339,202.455,320.288,199.768,323.856,199.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC1ED"
    },
    d: "M99.524,200.91v-66.525c0-2.75,2.25-5,5-5H84.682c-2.75,0-5,2.25-5,5v66.525c0,2.75,2.25,5,5,5 h19.842C101.774,205.91,99.524,203.66,99.524,200.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M424.699,84.983H25.457c-1.684,0-3.061,1.377-3.061,3.062v21.953H427.76V88.045 C427.76,86.36,426.382,84.983,424.699,84.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9518"
    },
    d: "M45.3,84.983H25.457c-1.684,0-3.061,1.377-3.061,3.062v21.953h19.842V88.045 C42.239,86.36,43.616,84.983,45.3,84.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M171.504,238.979h-84.17c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h84.17 c4.142,0,7.5,3.357,7.5,7.5S175.646,238.979,171.504,238.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M171.504,263.466h-84.17c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h84.17 c4.142,0,7.5,3.357,7.5,7.5C179.004,260.108,175.646,263.466,171.504,263.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M171.504,287.953h-84.17c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h84.17 c4.142,0,7.5,3.357,7.5,7.5S175.646,287.953,171.504,287.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M237.56,238.979h-43.326c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h43.326 c4.142,0,7.5,3.357,7.5,7.5S241.702,238.979,237.56,238.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M237.56,263.466h-43.326c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h43.326 c4.142,0,7.5,3.357,7.5,7.5C245.06,260.108,241.702,263.466,237.56,263.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M237.56,287.953h-43.326c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h43.326 c4.142,0,7.5,3.357,7.5,7.5S241.702,287.953,237.56,287.953z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#445EA0"
    },
    d: "M504,198.768c4.4,0,8,3.6,8,8v241.77c0,4.4-3.6,8-8,8H323.856c-4.4,0-8-3.6-8-8v-241.77 c0-4.4,3.6-8,8-8L504,198.768L504,198.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M337.567,425.125c-2.75,0-5-2.25-5-5V219.18c0-2.75,2.25-5,5-5H490.29c2.75,0,5,2.25,5,5v200.945 c0,2.75-2.25,5-5,5H337.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9EAFC"
    },
    d: "M352.409,420.125V219.18c0-2.75,2.25-5,5-5h-19.842c-2.75,0-5,2.25-5,5v200.945c0,2.75,2.25,5,5,5 h19.842C354.659,425.125,352.409,422.875,352.409,420.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#445EA0"
    },
    d: "M404.567,445.125c-2.75,0-5-2.25-5-5v-1.945c0-2.75,2.25-5,5-5h18.723c2.75,0,5,2.25,5,5v1.945 c0,2.75-2.25,5-5,5H404.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M495.29,233.473V219.18c0-2.75-2.25-5-5-5H337.567c-2.75,0-5,2.25-5,5v14.293L495.29,233.473 L495.29,233.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9518"
    },
    d: "M357.409,214.18h-19.842c-2.75,0-5,2.25-5,5v14.293h19.842V219.18 C352.409,216.43,354.659,214.18,357.409,214.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M448.013,324.933h-68.169c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h68.169 c4.142,0,7.5,3.357,7.5,7.5C455.513,321.575,452.155,324.933,448.013,324.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M448.013,348.06h-68.169c-4.142,0-7.5-3.357-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h68.169 c4.142,0,7.5,3.358,7.5,7.5C455.513,344.703,452.155,348.06,448.013,348.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M448.013,371.185h-68.169c-4.142,0-7.5-3.357-7.5-7.5c0-4.142,3.358-7.5,7.5-7.5h68.169 c4.142,0,7.5,3.358,7.5,7.5C455.513,367.828,452.155,371.185,448.013,371.185z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M479.756,292.257c0,2.75-2.25,5-5,5H353.101c-2.75,0-5-2.25-5-5v-41.244c0-2.75,2.25-5,5-5h121.655 c2.75,0,5,2.25,5,5V292.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC1ED"
    },
    d: "M367.943,292.257v-41.244c0-2.75,2.25-5,5-5h-19.842c-2.75,0-5,2.25-5,5v41.244c0,2.75,2.25,5,5,5 h19.842C370.193,297.257,367.943,295.007,367.943,292.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DDF4"
    },
    d: "M461.757,409.416c0,2.75-2.25,5-5,5H371.1c-2.75,0-5-2.25-5-5v-16.91c0-2.75,2.25-5,5-5h85.657 c2.75,0,5,2.25,5,5L461.757,409.416L461.757,409.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC1ED"
    },
    d: "M385.942,409.416v-16.91c0-2.75,2.25-5,5-5H371.1c-2.75,0-5,2.25-5,5v16.91c0,2.75,2.25,5,5,5h19.842 C388.192,414.416,385.942,412.166,385.942,409.416z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulos);
export default __webpack_public_path__ + "static/media/modulos.3c00b323926e15aaf0b1ef88f5d74012.svg";
export { ForwardRef as ReactComponent };